module.exports = __webpack_public_path__ + "static/media/topCreate.78acd079.svg";